import React from "react";
import Marquee from "react-fast-marquee";
import { CLIENTS } from "@/data/site";

const ClientMarquee = ({ speed = 40 }) => {
  return (
    <div className="py-4" data-testid="client-marquee">
      <Marquee gradient gradientColor="#171726" gradientWidth={140} speed={speed} pauseOnHover>
        {CLIENTS.map((c, i) => (
          <span key={i} className="flex items-center">
            <span className="client-logo text-2xl md:text-4xl mx-10">{c}</span>
            <span
              className="mx-2 w-2.5 h-2.5"
              style={{ backgroundColor: "#edaa51", clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)", opacity: 0.6 }}
            />
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default ClientMarquee;
